import { Component, OnInit } from '@angular/core';
import { Global } from 'src/app/shared/global';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  constructor(public global: Global, public router: Router) { }

  ngOnInit(): void {
  }
  next(): void {
    //this.router.navigateByUrl('/plan-for-year');
    this.router.navigate(['/plan-for-year'], { queryParams: { org: this.global.orgID } });
  }
  redirectFormPage(): void {
    this.router.navigate(['/user-intro'], { queryParams: { org: this.global.orgID } });
  }

}
